import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M10.0757 16.7728L6.17573 12.8728C5.94142 12.6385 5.94142 12.2586 6.17573 12.0243L7.02424 11.1757C7.25854 10.9414 7.63846 10.9414 7.87277 11.1757L10.5 13.8029L16.1272 8.17573C16.3615 7.94142 16.7415 7.94142 16.9758 8.17573L17.8243 9.02426C18.0586 9.25857 18.0586 9.63846 17.8243 9.87279L10.9243 16.7728C10.6899 17.0071 10.31 17.0071 10.0757 16.7728V16.7728Z" />
  </svg>
);
export default SvgCheck;
